export default __webpack_public_path__ + "static/media/peperoni.02b14fee.mp3";